import { connect } from "react-redux";
import {
    clearAnnotation,
    deleteAnnotation,
    mouseEnterAnnotation,
    mouseLeaveAnnotation,
    setAnnotation,
} from "../actions";
import { AnnotationContent, AnnotationContentProps } from "../components/ImageAnnotationsContent";
import { AnnotationsPartialState } from "../reducers/dtos";

const mapStateToProps = (
    state: AnnotationsPartialState,
    props: Partial<AnnotationContentProps>
): Partial<AnnotationContentProps> => ({
    editingAnnotation: state.imageAnnotations.annotation,
    attachmentId: state.imageAnnotations.image.attachmentId,
    projectOrTask: state.imageAnnotations.messageEditorInfo.projectOrTask,
});

const mapDispatchToProps: Partial<AnnotationContentProps> = {
    clearAnnotation,
    setAnnotation,
    deleteAnnotation,
    mouseEnterAnnotation,
    mouseLeaveAnnotation,
};

export const AnnotationContentContainer = connect(mapStateToProps, mapDispatchToProps)(AnnotationContent);
